import { resolveToastVariant } from "Helpers/toastVariant";

export const ACTION_TYPES = {
	TOAST_MESSAGE_ENABLE: "TOAST_MESSAGE_ENABLE",
	TOAST_MESSAGE_DISABLE: "TOAST_MESSAGE_DISABLE",
	QUIZ_SOUND: "QUIZ_SOUND",
};

/**
 * Show the in-game event banner.
 *
 * @param {string} message  text shown in the banner
 * @param {string} [variant] optional — "success" | "error" | "warning" | "info".
 *                           When omitted the variant is inferred from the message
 *                           (see Helpers/toastVariant), so existing calls keep working.
 * @param {string} [title]   optional — overrides the auto headline ("Correct!", "Oops"…)
 */
export const showToast = (message, variant, title) => {
	return {
		type: ACTION_TYPES.TOAST_MESSAGE_ENABLE,
		message: message || "",
		variant: resolveToastVariant(message, variant),
		title: title || "",
	};
};

export const hideToast = () => {
	return {
		type: ACTION_TYPES.TOAST_MESSAGE_DISABLE,
	};
};

export const quizSound = (value) => {
	return {
		type: ACTION_TYPES.QUIZ_SOUND,
		QuizSound: value,
	};
};
